import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex px-5 md:px-40 mb-8 p-3" }

import { computed, ref, onMounted, onBeforeMount } from 'vue'
import Stepper from '@/views/components/stepper/Horizontal.vue'
import Card from 'primevue/card'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import EmployeeForm from './components/form/EmployeeForm.vue'
import EmployeeContractForm from './components/form/EmployeeContractForm.vue'
import EmployeeDocumentForm from './components/form/EmployeeDocumentForm.vue'
import EmployeeEmergencyContact from './components/form/EmployeeEmergencyContact.vue'

const moduleStore = 'employee'

export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const store = useStore()
const route = useRoute()
const canJump = ref(true)
const steps = ref(route.params.id ? [{
  key: 1,
  titleCircle: '1',
  title: 'Informasi Karyawan',
  iconDone: ''
},
{
  key: 2,
  titleCircle: '2',
  title: 'Kontrak Divisi',
  iconDone: ''
},
{
  key: 4,
  titleCircle: '3',
  title: 'Kontak Darurat',
  iconDone: ''
}] : [{
  key: 1,
  titleCircle: '1',
  title: 'Informasi Karyawan',
  iconDone: ''
},
{
  key: 2,
  titleCircle: '2',
  title: 'Kontrak Divisi',
  iconDone: ''
},
{
  key: 3,
  titleCircle: '3',
  title: 'Dokumen Penting',
  iconDone: ''
},
{
  key: 4,
  titleCircle: '4',
  title: 'Kontak Darurat',
  iconDone: ''
}])

// const selectedStep = ref(1)

const selectedStep = computed({
  get: () => store.state[moduleStore].formStep,
  set: (value) => {
    store.dispatch('employee/setEmployeeFormStep', value)
  }
})

const onChangeStepper = (value: any) => {
  // console.log('key', value)
  selectedStep.value = value.key
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Master Karyawan',
      routeName: 'master-employee'
    },
    {
      title: `${route.params.id ? 'Edit' : 'Tambah'} Karyawan`,
      routeName: ''
    },
    {
      title: steps.value.filter((d: any) => d.key === selectedStep.value)[0].title,
      routeName: 'master-employee-form',
      params: { id: route.params.id }
    }
  ])
}

onBeforeMount(() => {
  // console.log('route.params.id', route.params.id)
  // console.log('route.params.id>>>>>', encryptDecriptMethods.decrypt(route.params.id))
  if (!route.params.id) {
    canJump.value = false
  }
  selectedStep.value = 1
  store.dispatch('employee/flushEmployeeData')
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Master Karyawan',
      routeName: 'master-employee'
    },
    {
      title: `${route.params.id ? 'Edit' : 'Tambah'} Karyawan`,
      routeName: ''
    },
    {
      title: steps.value.filter((d: any) => d.key === selectedStep.value)[0].title,
      routeName: 'master-employee-form',
      params: { id: route.params.id }
    }
  ])
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(Stepper, {
            items: steps.value,
            value: selectedStep.value,
            isCanClicked: canJump.value,
            onOnChange: onChangeStepper
          }, null, 8, ["items", "value", "isCanClicked"])
        ]),
        (selectedStep.value === 1)
          ? (_openBlock(), _createBlock(EmployeeForm, { key: 0 }))
          : (selectedStep.value === 2)
            ? (_openBlock(), _createBlock(EmployeeContractForm, { key: 1 }))
            : (selectedStep.value === 3)
              ? (_openBlock(), _createBlock(EmployeeDocumentForm, { key: 2 }))
              : (selectedStep.value === 4)
                ? (_openBlock(), _createBlock(EmployeeEmergencyContact, { key: 3 }))
                : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})